import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import CheckIcon from "@mui/icons-material/Check";
import { formatIsoDateBR } from "~/utils/format";

// Mesmo desenho do PaymentDateCell (antecipacoes): campo de data + salvar; Enter também salva.
export default function NormalPaymentDateCell({ row, editable, onSave }) {
  const original = (row.normal_payment_date || "").slice(0, 10);
  const [value, setValue] = useState(original);
  const [saving, setSaving] = useState(false);
  // O DataGrid reaproveita a célula: quando a lista recarrega com a data salva, o campo acompanha.
  useEffect(() => setValue(original), [original]);

  if (!editable) return <span>{formatIsoDateBR(row.normal_payment_date) || "—"}</span>;

  // Salvar a mesma data também vale: o backend recalcula o deságio antes do contrato ir para o médico.
  const canSave = Boolean(value) && !saving;
  const save = async () => {
    if (!canSave) return;
    setSaving(true);
    try {
      await onSave(row.id, value);
    } finally {
      setSaving(false);
    }
  };
  // O DataGrid captura teclas (espaço/setas): a célula para a propagação; Enter salva.
  const onKeyDown = (e) => {
    e.stopPropagation();
    if (e.key === "Enter") save();
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <TextField
        type="date"
        size="small"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKeyDown}
        inputProps={{ "aria-label": `Data de pagamento normal do plantão #${row.id}` }}
        sx={{ width: 150, "& input": { py: "6px", fontSize: 13 } }}
      />
      <Tooltip title="Salvar data">
        <span>
          <IconButton
            aria-label={`Salvar data de pagamento normal do plantão #${row.id}`}
            color="primary"
            disabled={!canSave}
            onClick={save}
            sx={{ width: 40, height: 40, bgcolor: canSave ? "#e0f7fc" : undefined }}
          >
            {saving ? <CircularProgress size={18} /> : <CheckIcon fontSize="small" />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
}
